export const version = "ethers/5.4.7";
//# sourceMappingURL=_version.js.map